import { axiosInstance } from 'app/api/axiosInstance';
import AsyncStorage from '@react-native-async-storage/async-storage';
import type { AxiosError } from 'axios';
import { TSBAuthResponse } from 'app/types';
import { Telemetry } from 'app/services/telemetry/Telemetry';


export class SBTokenService {
  static async requestToken(): Promise<void> {
    try {
      // TECHDEBT
      // Issue: https://app.clickup.com/t/86c8fp9eg
      // Description: Direct axiosInstance call bypassing React Query - consider wrapping in useQuery or keeping as low-level service
      // Tech Debt - this endpoint should be moved to a dedicated module
      const response = await axiosInstance.get<TSBAuthResponse>(
        '/rpm/api/v1/chats/initialize-session'
      );
      await AsyncStorage.setItem(
        'sb_token',
        JSON.stringify(response.data.token)
      );
    } catch (error) {
      const axiosError = error as AxiosError;
      Telemetry.error(error, { 
        event:'auth.sendbird_token.request.fail', 
        domain:'auth',
        status: axiosError.response?.status
      });
      throw error;
    }
  }

  static async getToken(): Promise<string> {
    try {
      const token = await AsyncStorage.getItem('sb_token');
      return token ? JSON.parse(token) : '';
    } catch (error) {
      Telemetry.error(error, { event:'auth.sendbird_token.get.fail', domain:'auth' });
      throw error;
    }
  }

  static async clearToken(): Promise<void> {
    try {
      await AsyncStorage.removeItem('sb_token');
    } catch (error) {
      Telemetry.error(error, { event:'auth.sendbird_token.clear.fail', domain:'auth' });
      throw error;
    }
  }
}
